import {i18n} from '@yourcoach/i18n';

import type {PrivateProfile, UserApiModel} from '../../api/user';

import {currentUserStore} from '../../api/user';
import AlarmIcon from '../../assets/icons/alarm.svg';
import {alert} from '../../components/alert';
import {TestID} from '../../utils/test-utils/data-test-id';

const allowedFields = ['gender', 'location', 'phone'] as const;

export const askToFillPrivateProfileIfNeeded = (data: {
  coords?: UserApiModel['coords'];
  gender?: UserApiModel['gender'];
  location?: UserApiModel['location'];
  phone?: string;
}) =>
  new Promise<void>(resolve => {
    const {user} = currentUserStore;

    if (!user) {
      resolve();

      return;
    }

    const fields: {
      [key in (typeof allowedFields)[number]]?: string;
    } = {};

    Object.keys(data)
      .filter(key => {
        return (
          allowedFields.includes(key as (typeof allowedFields)[0]) &&
          user.private_profile[key] !== undefined &&
          data[key] &&
          data[key] !== user.private_profile[key]
        );
      })
      .forEach(key => {
        fields[key] = data[key];
      });

    if (!Object.keys(fields).length) {
      resolve();

      return;
    }

    alert.show({
      buttons: [
        {
          label: i18n.t('shared:services.sync_private_profile.success_button'),
          onClick: async () => {
            const privateProfile: Partial<PrivateProfile> =
              fields as Partial<PrivateProfile>;

            if (fields.location) {
              privateProfile.coords = data.coords;
            }

            currentUserStore
              .update({
                b2b: {
                  private_profile: privateProfile,
                },
                core: {
                  // @ts-expect-error: TODO: describe why
                  private_profile: privateProfile,
                },
              })
              .catch(() => {});

            resolve();
          },
          scheme: 'primary',
          testID: TestID.sync_private_profile.button.sync,
        },
        {
          label: i18n.t('shared:services.sync_private_profile.cancel_button'),
          onClick: async () => {
            resolve();
          },
          testID: TestID.sync_private_profile.button.cancel,
        },
      ],
      icon: AlarmIcon,
      iconColor: 'global2',
      /**
       * @i18n_parser
       *
       * t('shared:services.sync_private_profile.gender_label')
       * t('shared:services.sync_private_profile.location_label')
       * t('shared:services.sync_private_profile.phone_label')
       * t('shared:services.sync_private_profile.and_label')
       */
      message: i18n.t('shared:services.sync_private_profile.message', {
        fields: Object.keys(fields)
          .map((key, i, itself) => {
            let str = i18n.t(
              `shared:services.sync_private_profile.${key}_label`,
            );

            if (itself.length > 1 && i === itself.length - 1) {
              str = `${i18n.t('shared:services.sync_private_profile.and_label')} ${str}`;
            }

            return str;
          })
          .join(' '),
      }),
      testID: TestID.sync_private_profile.alert,
      variant: 'promo',
    });
  });
